import { AUTHOR_TYPES } from "../../../../packages/constants";

const getRole = (
  authorId: string,
  userId: string,
  authorRole: string
): AUTHOR_TYPES => {
  if (authorRole === AUTHOR_TYPES.BOT) {
    return AUTHOR_TYPES.BOT;
  }

  if (authorId === userId) {
    return AUTHOR_TYPES.USER;
  }

  return AUTHOR_TYPES.OPPONENT;
};

export { getRole };
